import { useState, useEffect, useCallback } from 'react';
import { get, post, put, remove } from '../../../Services/http';

export const statusType = {
  pending: 'pending',
  success: 'success',
  error: 'error',
};

export const useBCApi = (path, immediate) => {
  const [status, setStatus] = useState('idle');
  const [value, setValue] = useState(null);
  const [error, setError] = useState(null);
  const [mounted, setMounted] = useState(true);

  const execute = useCallback(
    async (method, data, urlParams = '') => {
      setStatus(statusType.pending);
      setValue(null);
      setError(null);
      try {
        const response = await query(path, method, data, urlParams);
        if (mounted) {
          setValue(response);
          setStatus(statusType.success);
        }
      } catch (error) {
        if (mounted) {
          error.response?.json().then((error) => setError(error));
          setStatus(statusType.error);
        }
      }
    },
    [mounted, path]
  );

  useEffect(() => {
    if (immediate) {
      execute();
    }
    return () => {
      setMounted(false);
    };
  }, [execute, immediate]);

  return { execute, status, value, error };
};

const query = async (path, method = 'GET', data, urlParams) => {
  path += urlParams;
  var res;
  if (method === 'GET') {
    res = await get(path);
  } else if (method === 'POST') {
    res = await post(path, data);
  } else if (method === 'PUT') {
    res = await put(path, data);
  } else if (method === 'DELETE') {
    res = await remove(path, data);
  }

  if (res.ok) {
    try {
      const txt = await res.text();
      if (txt === '') {
        return null;
      }
      return JSON.parse(txt);
    } catch (error) {
      throw new Error('Invalid JSON response from server.');
    }
  }

  throw new Error(res.json());
};
